import IAuthState from '../../interfaces/reducers/IAuthState';

const authInitialState: IAuthState = {
  isAuth: false,
  accessToken: '',
  firebaseToken: '',
};

export default authInitialState;
